var bodyLargeStrong = '_14wijgr8';
var bodyMediumStrong = '_14wijgra';
var displayContents = '_14wijgr1';
var positionAbsolute = '_14wijgr2';
var srOnly = '_14wijgr0';

export { bodyLargeStrong, bodyMediumStrong, displayContents, positionAbsolute, srOnly };
//# sourceMappingURL=composables.css.js.map
